import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const typeformBlockEl = document.getElementById('js-typeform-block');
let navigationHistory = [];
let focusReturn;

$(typeformBlockEl).on('click', function (e) {
  e.stopPropagation();
})

function openTypeform(step = 0) {
  disableBodyScroll(typeformBlockEl);
  $(typeformBlockEl).addClass('is-visible').attr('aria-hidden', 'false');

  navigationHistory = [];
  showTypeformStep(step);
}

$('.js-open-typeform').on('click', function (e) {
  e.stopPropagation();
  openTypeform(0);
  focusReturn = this;
});

function closeTypeForm() {
  enableBodyScroll(typeformBlockEl);
  $(typeformBlockEl).removeClass('is-visible').attr('aria-hidden', 'true');
  $(focusReturn).focus();
  focusReturn = null;
};

$('.js-close-typeform, body').on('click', function (e) {
  e.stopPropagation();
  closeTypeForm();
});

$('.js-back-typeform').on('click', function () {
  if (navigationHistory.length > 1) {
    navigationHistory.pop();
    showTypeformStep(navigationHistory.pop(), true, true);
  }
  else {
    showTypeformStep(0, false, true);
  }
})

$(typeformBlockEl).find('[typeform-target]').on('click', function () {
  showTypeformStep($(this).attr('typeform-target'));
});

$(typeformBlockEl).find('.focus-trap:first-child').on('focus', function () {
  $(typeformBlockEl).find('.hide').focus();
});

$(typeformBlockEl).find('.focus-trap:last-child').on('focus', function () {
  focusQuestion();
});

function focusQuestion() {
  setTimeout(() => {
    $(typeformBlockEl).find('.is-current').find('[tabindex]').first().focus();
  }, 200);
}

function showTypeformStep(step, flagHistory = true, isBack = false) {
  if (navigationHistory.length || isBack) {
    if (isBack) {
      $(typeformBlockEl).find('.question.is-current').addClass('is-moving is-below').removeClass('is-current');

      $(typeformBlockEl).find(`[typeform-step="${step}"]`).addClass('is-above');
      setTimeout(() => {
        $(typeformBlockEl).find(`[typeform-step="${step}"]`).removeClass('is-above').addClass('is-moving is-current');
      }, 100);
    }
    else {
      $(typeformBlockEl).find('.question.is-current').addClass('is-moving is-above').removeClass('is-current');

      $(typeformBlockEl).find(`[typeform-step="${step}"]`).addClass('is-below');
      setTimeout(() => {
        $(typeformBlockEl).find(`[typeform-step="${step}"]`).removeClass('is-below').addClass('is-moving is-current');
      }, 100);
    }
  }
  else {
    $(typeformBlockEl).find('.question.is-current').removeClass('is-current');
    $(typeformBlockEl).find(`[typeform-step="${step}"]`).addClass('is-current');
  }

  focusQuestion();

  setTimeout(() => {
    $(typeformBlockEl).find('.question').removeClass('is-moving is-above is-below');
  }, 400);

  if (flagHistory) {
    navigationHistory.push(parseInt(step));
  }

  if (navigationHistory.length > 1) {
    $('.js-back-typeform').removeAttr('disabled');
  }
  else {
    $('.js-back-typeform').attr('disabled', 'disabled');
  }
}

/* PCPME SIREN Form */
$('#typeform-siren-pcpme').on('submit', function (e) {
  e.preventDefault();

  const input = $('#typeform-siren').val();

  $(this).find('.ds-loader').addClass('is-visible');

  $.ajax({
    url: `/entreprise-service/entreprises?siren=${input}`
  }).then(function (data) {
    const migration = data.migration;

    if (migration === 'true') { // Nouvel espace
      window.tc_vars = window.tc_vars || {};   
      tc_vars.statut_migration = 'Nouveau migré'; 
      showTypeformStep(6)
    }
    else if (migration === 'false') { // Ancien espace
      window.tc_vars = window.tc_vars || {};   
      tc_vars.statut_migration = 'Ancien migré'; 
      showTypeformStep(7)
    }
    else if (migration === 'UNKNOWN') { // Client Mixte
      window.tc_vars = window.tc_vars || {};   
      tc_vars.statut_migration = 'Non migré'; 
      showTypeformStep(8)
    }
    else  { // migration === null ou autre retour API inconnu
      showTypeformStep(9)
    }

    $('#loader').removeClass('is-visible');
  }).fail(function () {
    $('#typeform-siren').removeClass('valide').addClass('erreur');
    $('#loader').removeClass('is-visible');
  });
})

$('#typeform-siren').on('input', function () {
  if ($(this).val().length === 9) {
    $(this).addClass('valide').removeClass('erreur');
    $('#typeform-siren-pcpme button').removeAttr('disabled');
  }
  else {
    $(this).removeClass('valide').removeClass('erreur');
    $('#typeform-siren-pcpme button').attr('disabled', 'disabled');
  }
})


$('.js-triptique-toggle-images').on('click', function () {
  $('.typeform-tp-container img').toggleClass('is-visible');
})

if (window.location.hash && window.location.hash == "#siren") {
  openTypeform(1)
}